import { render, staticRenderFns } from "./ModalCreateNewContext.vue?vue&type=template&id=637913de&scoped=true"
import script from "./ModalCreateNewContext.vue?vue&type=script&lang=js"
export * from "./ModalCreateNewContext.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateNewContext.vue?vue&type=style&index=0&id=637913de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637913de",
  null
  
)

export default component.exports